import React from "react";
import {useKakao} from "../hooks/kakaoHooks";
import {useParams, useSearchParams} from "react-router-dom";

const KakaoLoginButton = () => {
    const { kakaoLogin } = useKakao()
    const [searchParams] = useSearchParams()
    const redirect = searchParams.get('redirect')

    return (
        <img src={"https://k.kakaocdn.net/14/dn/btroDszwNrM/I6efHub1SN5KCJqLm1Ovx1/o.jpg"}
             alt={"카카오 로그인 버튼"}
             onClick={() => kakaoLogin(redirect)}
        />
    )
}

export default KakaoLoginButton;
